// import React, { useRef, useState, useEffect } from 'react';
// import { socket } from '../socket';
// import './VoiceChat.css';

// const VoiceChat = () => {
//   const localRef = useRef();
//   const remoteRef = useRef();
//   const [pc, setPc] = useState(null);

//   const [callState, setCallState] = useState('idle'); 
//   const [incomingOffer, setIncomingOffer] = useState(null);
//   const [callerName, setCallerName] = useState('');

//   const endCall = () => {
//     if (pc) {
//       pc.close();
//       setPc(null);
//     }
//     if (localRef.current?.srcObject) {
//       localRef.current.srcObject.getTracks().forEach(t => t.stop());
//       localRef.current.srcObject = null;
//     }
//     if (remoteRef.current) remoteRef.current.srcObject = null;

//     socket.emit('end-call');
//     setCallState('idle');
//     setIncomingOffer(null);
//     setCallerName('');
//   };

//   const declineCall = () => {
//     socket.emit('call-declined');
//     setCallState('idle');
//     setIncomingOffer(null);
//     setCallerName('');
//   };

//   useEffect(() => {
//     socket.on('voice-offer', (data) => {
//       setIncomingOffer(data.sdp);
//       setCallState('receiving');
//       setCallerName(data.callerName || 'Unknown');
//     });

//     socket.on('voice-answer', (data) => {
//       if (pc) {
//         pc.setRemoteDescription(new RTCSessionDescription(data.sdp));
//         setCallState('connected');
//       }
//     });

//     socket.on('ice-candidate', (data) => {
//       if (pc && data.candidate) {
//         pc.addIceCandidate(new RTCIceCandidate(data.candidate));
//       }
//     });

//     socket.on('call-ended', () => endCall());
//     socket.on('call-declined', () => declineCall());

//     return () => {
//       socket.off('voice-offer');
//       socket.off('voice-answer');
//       socket.off('ice-candidate');
//       socket.off('call-ended');
//       socket.off('call-declined');
//     };
//   }, [pc]);

//   const createPeerConnection = () => {
//     const peer = new RTCPeerConnection({
//       iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
//     });

//     peer.onicecandidate = (e) => {
//       if (e.candidate) socket.emit('ice-candidate', { candidate: e.candidate });
//     };

//     peer.ontrack = (e) => {
//       if (remoteRef.current) remoteRef.current.srcObject = e.streams[0];
//     };

//     peer.onconnectionstatechange = () => {
//       if (peer.connectionState === 'connected') {
//         setCallState('connected');
//       } else if (['disconnected', 'failed'].includes(peer.connectionState)) {
//         endCall();
//       }
//     };

//     return peer;
//   };

//   const startCall = async () => {
//     try {
//       setCallState('calling');
//       const peer = createPeerConnection();
//       setPc(peer);

//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       localRef.current.srcObject = stream;
//       stream.getTracks().forEach(t => peer.addTrack(t, stream));

//       const offer = await peer.createOffer();
//       await peer.setLocalDescription(offer);

//       socket.emit('voice-offer', { sdp: offer });
//     } catch {
//       setCallState('idle');
//     }
//   };

//   const answerCall = async () => {
//     try {
//       const peer = createPeerConnection();
//       setPc(peer);

//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       localRef.current.srcObject = stream;
//       stream.getTracks().forEach(t => peer.addTrack(t, stream));

//       await peer.setRemoteDescription(new RTCSessionDescription(incomingOffer));
//       const answer = await peer.createAnswer();
//       await peer.setLocalDescription(answer);

//       socket.emit('voice-answer', { sdp: answer });
//       setCallState('connected');
//       setIncomingOffer(null);
//     } catch {
//       declineCall();
//     }
//   };

//   const renderCallControls = () => {
//     switch (callState) {
//       case 'idle':
//         return (
//           <button onClick={startCall} className="voicechat-btn voice-btn-idle">
//             <i className="fas fa-phone-alt"></i>
//           </button>
//         );

//       case 'calling':
//         return (
//           <div className="voice-status-card">
//             <div className="voice-pulse-ring"></div>
//             <span className="voice-status-text">Calling...</span>
//             <button onClick={endCall} className="voice-btn-end icon-only">
//               <i className="fas fa-times"></i>
//             </button>
//           </div>
//         );

//       case 'receiving':
//         return (
//           <div className="voice-incoming-modal">
//             <div className="voice-incoming-content">
//               <div className="voice-avatar-pulse">
//                 <i className="fas fa-user"></i>
//               </div>
//               <div className="voice-incoming-text">
//                 <span className="label">Incoming Call</span>
//                 <span className="name">{callerName}</span>
//               </div>

//               <div className="voice-actions">
//                 <button onClick={declineCall} className="voice-btn-decline">
//                   <i className="fas fa-phone-slash"></i>
//                 </button>
//                 <button onClick={answerCall} className="voice-btn-answer">
//                   <i className="fas fa-phone"></i>
//                 </button>
//               </div>
//             </div>
//           </div>
//         );

//       case 'connected':
//         return (
//           <div className="voice-connected-bar">
//             <div className="voice-live-indicator">
//               <span className="bar"></span>
//               <span className="bar"></span>
//               <span className="bar"></span>
//             </div>

//             <span className="connected-text">Live Audio</span>

//             <button onClick={endCall} className="voice-btn-end-small">
//               <i className="fas fa-phone-slash"></i>
//             </button>
//           </div>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="voice-container">
//       {renderCallControls()}
//       <audio ref={localRef} autoPlay muted />
//       <audio ref={remoteRef} autoPlay />
//     </div>
//   );
// };

// export default VoiceChat;




import React, { useRef, useState, useEffect } from 'react';
import { socket } from '../socket';
import './VoiceChat.css';

const VoiceChat = () => {
  const localRef = useRef();
  const remoteRef = useRef();

  // store pc in ref so event listeners/handlers always see current one
  const pcRef = useRef(null);

  // queue incoming remote descriptions & ICE candidates that arrive before pc creation
  const pendingRemoteDescRef = useRef(null);
  const pendingIceRef = useRef([]);

  const [callState, setCallState] = useState('idle'); 
  const [incomingOffer, setIncomingOffer] = useState(null);
  const [callerName, setCallerName] = useState('');

  // ---- helper: create a fresh RTCPeerConnection and wire events ----
  const createPeerConnection = () => {
    const peer = new RTCPeerConnection({
      iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
    });

    peer.onicecandidate = (e) => {
      if (e.candidate) {
        socket.emit('ice-candidate', { candidate: e.candidate });
      }
    };

    peer.ontrack = (e) => {
      if (remoteRef.current) {
        remoteRef.current.srcObject = e.streams[0];
      }
    };

    peer.onconnectionstatechange = () => {
      if (peer.connectionState === 'connected') {
        setCallState('connected');
      } else if (['disconnected', 'failed', 'closed'].includes(peer.connectionState)) {
        // ensure a clean end
        cleanupPeer();
      }
    };

    // attach queued remote description / ICEs if any
    if (pendingRemoteDescRef.current) {
      try {
        peer.setRemoteDescription(new RTCSessionDescription(pendingRemoteDescRef.current))
          .catch(err => console.warn('Failed applying queued remote description:', err));
      } finally {
        pendingRemoteDescRef.current = null;
      }
    }

    if (pendingIceRef.current.length > 0) {
      pendingIceRef.current.forEach(cand => {
        peer.addIceCandidate(new RTCIceCandidate(cand)).catch(err => {
          console.warn('Failed adding queued ICE candidate:', err);
        });
      });
      pendingIceRef.current = [];
    }

    pcRef.current = peer;
    return peer;
  };

  const cleanupPeer = () => {
    try {
      const pc = pcRef.current;
      if (pc) {
        try { pc.ontrack = null; } catch(e){}
        try { pc.onicecandidate = null; } catch(e){}
        try { pc.onconnectionstatechange = null; } catch(e){}
        try { pc.close(); } catch(e){}
      }
    } catch (err) {
      console.warn('cleanupPeer error:', err);
    }
    pcRef.current = null;

    // stop and clear local audio
    try {
      if (localRef.current && localRef.current.srcObject) {
        localRef.current.srcObject.getTracks().forEach(t => t.stop());
        localRef.current.srcObject = null;
      }
    } catch (err) {
      console.warn('stop local stream error:', err);
    }

    // clear remote audio
    if (remoteRef.current) {
      try { remoteRef.current.srcObject = null; } catch(e){}
    }

    // clear any pending queues
    pendingRemoteDescRef.current = null;
    pendingIceRef.current = [];
  };

  const endCall = () => {
    // notify other peer
    socket.emit('end-call');

    // cleanup local peer & tracks
    cleanupPeer();

    // reset UI state
    setCallState('idle');
    setIncomingOffer(null);
    setCallerName('');
  };

  const declineCall = () => {
    socket.emit('call-declined');
    cleanupPeer();
    setCallState('idle');
    setIncomingOffer(null);
    setCallerName('');
  };

  // ---- signaling listeners (registered once) ----
  useEffect(() => {
    const onOffer = (data) => {
      // remote gave us an offer -> show incoming UI
      setIncomingOffer(data.sdp);
      setCallState('receiving');
      setCallerName(data.callerName || 'Unknown');
    };

    const onAnswer = (data) => {
      // caller receives answer
      const pc = pcRef.current;
      if (pc) {
        pc.setRemoteDescription(new RTCSessionDescription(data.sdp))
          .catch(err => console.error('setRemoteDescription (answer) failed', err));
      } else {
        // queue it — caller may not have created pc yet (race); store and apply when created
        pendingRemoteDescRef.current = data.sdp;
      }
    };

    const onIce = (data) => {
      const pc = pcRef.current;
      if (pc) {
        if (data?.candidate) {
          pc.addIceCandidate(new RTCIceCandidate(data.candidate)).catch(err => {
            console.warn('addIceCandidate failed', err);
          });
        }
      } else {
        // queue ICE to apply when pc created
        if (data?.candidate) pendingIceRef.current.push(data.candidate);
      }
    };

    const onCallEnded = () => {
      // remote hung up
      cleanupPeer();
      setCallState('idle');
      setIncomingOffer(null);
      setCallerName('');
    };

    const onCallDeclined = () => {
      cleanupPeer();
      setCallState('idle');
      setIncomingOffer(null);
      setCallerName('');
    };

    socket.on('voice-offer', onOffer);
    socket.on('voice-answer', onAnswer);
    socket.on('ice-candidate', onIce);
    socket.on('call-ended', onCallEnded);
    socket.on('call-declined', onCallDeclined);

    return () => {
      socket.off('voice-offer', onOffer);
      socket.off('voice-answer', onAnswer);
      socket.off('ice-candidate', onIce);
      socket.off('call-ended', onCallEnded);
      socket.off('call-declined', onCallDeclined);
    };
  }, []);

  // ---- start call (caller) ----
  const startCall = async () => {
    try {
      setCallState('calling');

      const peer = createPeerConnection();

      // get mic
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (localRef.current) localRef.current.srcObject = stream;

      // add tracks
      stream.getTracks().forEach(track => {
        try { peer.addTrack(track, stream); } catch (err) { console.warn('addTrack failed', err); }
      });

      // create & send offer
      const offer = await peer.createOffer();
      await peer.setLocalDescription(offer);

      socket.emit('voice-offer', { sdp: offer });
    } catch (err) {
      console.error('startCall error:', err);
      cleanupPeer();
      setCallState('idle');
    }
  };

  // ---- answer incoming call (callee) ----
  const answerCall = async () => {
    try {
      const peer = createPeerConnection();

      // get mic
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (localRef.current) localRef.current.srcObject = stream;

      stream.getTracks().forEach(track => {
        try { peer.addTrack(track, stream); } catch (err) { console.warn('addTrack failed', err); }
      });

      // apply remote offer (incomingOffer) — but it might be queued already
      const offer = incomingOffer || pendingRemoteDescRef.current;
      if (!offer) {
        console.warn('No offer to answer');
        // remain in receiving state until offer arrives
        return;
      }

      await peer.setRemoteDescription(new RTCSessionDescription(offer));
      const answer = await peer.createAnswer();
      await peer.setLocalDescription(answer);

      socket.emit('voice-answer', { sdp: answer });

      // clear incoming offer state
      setIncomingOffer(null);
      setCallState('connected');
    } catch (err) {
      console.error('answerCall error:', err);
      declineCall();
    }
  };

  // ---- UI rendering based on state ----
  const renderCallControls = () => {
    switch (callState) {
      case 'idle':
        return (
          <button onClick={startCall} className="voicechat-btn voice-btn-idle">
            <i className="fas fa-phone-alt" />
          </button>
        );
      case 'calling':
        return (
          <div className="voice-status-card">
            <div className="voice-pulse-ring" />
            <span className="voice-status-text">Calling...</span>
            <button onClick={endCall} className="voice-btn-end icon-only">
              <i className="fas fa-times" />
            </button>
          </div>
        );
      case 'receiving':
        return (
          <div className="voice-incoming-modal">
            <div className="voice-incoming-content">
              <div className="voice-avatar-pulse"><i className="fas fa-user" /></div>
              <div className="voice-incoming-text">
                <span className="label">Incoming Call</span>
                <span className="name">{callerName}</span>
              </div>
              <div className="voice-actions">
                <button onClick={declineCall} className="voice-btn-decline">
                  <i className="fas fa-phone-slash" />
                </button>
                <button onClick={answerCall} className="voice-btn-answer">
                  <i className="fas fa-phone" />
                </button>
              </div>
            </div>
          </div>
        );
      case 'connected':
        return (
          <div className="voice-connected-bar">
            <div className="voice-live-indicator">
              <span className="bar" />
              <span className="bar" />
              <span className="bar" />
            </div>
            <span className="connected-text">Live Audio</span>
            <button onClick={endCall} className="voice-btn-end-small">
              <i className="fas fa-phone-slash" />
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="voice-container">
      {renderCallControls()}
      <audio ref={localRef} autoPlay muted />
      <audio ref={remoteRef} autoPlay />
    </div>
  );
};

export default VoiceChat;
